import { appendable } from "@tblabs/truffle/Core/appendable";
import { TableViewer } from "./TableViewer";


export class TableColumnV2<T>
{
    constructor(
        public Header: appendable[],
        public Mapping: (
            record: T,
            cell: appendable,
            row: appendable,
            table: TableViewer<T>) => appendable | appendable[]) { }
}
